import { WidgetAction } from 'models/WidgetModel';
import './SwitchChartTable.scss';
import { appAssets } from 'constants/assets';
import { useWidgetContext } from 'contexts/WidgetProvider';

const SwitchViewTable = () => {
  const { chartView, setState } = useWidgetContext();

  const ChartIcon = appAssets.icons.CHART;
  const TableIcon = appAssets.icons.TABLE;

  const handleTableClick = () => {
    setState({
      action: WidgetAction.SWITCH_CHART_TABLE,
      chartView: false,
      showLineChart: false,
    });
  };

  const handleChartClick = () => {
    setState({
      action: WidgetAction.SWITCH_CHART_TABLE,
      chartView: true,
      showLineChart: false,
    });
  };

  return (
    <div className="switchAction">
      <span className={!chartView ? 'active' : ''} onClick={handleTableClick}>
        <TableIcon className="icon" /> Table
      </span>{' '}
      <span className={chartView ? 'active' : ''} onClick={handleChartClick}>
        <ChartIcon className="icon" /> Chart
      </span>
    </div>
  );
};

export default SwitchViewTable;
